import { useEffect, useMemo, useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { updateReferral } from 'state/competition/reducer'
import { useAppDispatch } from 'state/hooks'
import { PlatformsData } from 'state/interfaces'

import { ZERO_ADDRESS } from '../../../constants/misc'
import { IUserInfo } from '../../../graphql/competition/UserInfo'
import useParsedQueryString from '../../../hooks/useParsedQueryString'
import { useReferrerByAccount } from '../../../state/competition/hooks'

export const useReferrer = (
  userInfo: IUserInfo,
  account?: string
): { isLoading: boolean; data: PlatformsData; error?: string } => {
  const queryParams = useParsedQueryString()
  const [queryReferrer, setQueryReferrererrer] = useState<{ error?: string; refCode?: number }>({})

  const referrer = useReferrerByAccount(account)
  const dispatch = useAppDispatch()

  const [searchParams, setSearchParams] = useSearchParams()

  useEffect(() => {
    if (queryReferrer.error) {
      removeQuery()
    }
  }, [queryReferrer.error])
  // parse query param
  useEffect(() => {
    if (!queryParams.ref) {
      return
    }
    if (typeof queryParams.ref !== 'string') {
      setQueryReferrererrer({ error: 'Invalid referrer query param' })
      return
    }
    try {
      const refCode = Number(queryParams.ref)
      if (refCode > 16000000) {
        setQueryReferrererrer({ error: 'Invalid referrer code' })
        return
      }
      setQueryReferrererrer({ refCode })
    } catch (e) {
      console.log(e)
      setQueryReferrererrer({ error: 'Invalid referrer code' })
    }
  }, [queryParams])

  // update state with GraphQL data
  useEffect(() => {
    if (
      account &&
      !userInfo.isLoading &&
      userInfo.data?.user &&
      userInfo.data.user.referrer &&
      userInfo.data.user.referrer.id !== ZERO_ADDRESS
    ) {
      dispatch(
        updateReferral({
          account,
          refCode: userInfo.data.user.referrer.refCode,
        })
      )
    }
  }, [userInfo, account])

  useEffect(() => {
    if (
      account &&
      !userInfo.isLoading &&
      (!userInfo.data?.user || !userInfo.data?.user?.referrer || userInfo.data?.user?.referrer.id == ZERO_ADDRESS) &&
      queryReferrer.refCode &&
      !referrer &&
      userInfo.data?.user?.refCode !== queryReferrer.refCode
    ) {
      dispatch(
        updateReferral({
          account,
          refCode: queryReferrer.refCode,
        })
      )
    }
  }, [userInfo, account, queryReferrer, referrer])

  function removeQuery() {
    if (queryParams) {
      const newQueryParams = Object.keys(queryParams).reduce(
        (prev, curr) => (curr === 'ref' ? prev : { ...prev, [curr]: queryParams[curr] }),
        {}
      )

      setSearchParams(newQueryParams)
    }
  }
  return useMemo(() => {
    return {
      isLoading: userInfo.isLoading && !userInfo.data?.user,
      data: {
        contract: userInfo.data?.user?.referrer?.refCode,
        front: referrer,
        query: queryReferrer.refCode,
      },
      removeQuery,
    }
  }, [userInfo, referrer, queryReferrer])
}
